import { render, staticRenderFns } from "./MaterialDialog.vue?vue&type=template&id=bd6a7772&scoped=true&"
import script from "./MaterialDialog.vue?vue&type=script&lang=js&"
export * from "./MaterialDialog.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDialog.vue?vue&type=style&index=0&id=bd6a7772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6a7772",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd6a7772')) {
      api.createRecord('bd6a7772', component.options)
    } else {
      api.reload('bd6a7772', component.options)
    }
    module.hot.accept("./MaterialDialog.vue?vue&type=template&id=bd6a7772&scoped=true&", function () {
      api.rerender('bd6a7772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mass/components/MaterialDialog.vue"
export default component.exports